/* eslint-disable camelcase */
import { SVGAttributes } from 'react'
import { DSSizes } from '../../common/types'
import classy from 'shared/utils/classy'
import {
  ActivityIcon,
  AI,
  Airplay,
  Airpods,
  AlarmClock,
  AlarmClockCheck,
  AlarmClockMinus,
  AlarmClockOff,
  AlarmClockPlus,
  AlertCircleIcon,
  AlertTriangleIcon,
  AlignCenterIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowNarrowDownLeftIcon,
  ArrowNarrowUpRightIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AtSignIcon,
  Attachment01Icon,
  BarChart01Icon,
  BarChart02Icon,
  BarChart03Icon,
  BarChart04Icon,
  BarChart05Icon,
  BarChart06Icon,
  BarChart07Icon,
  BarChart08Icon,
  BarChart09Icon,
  BarChart10Icon,
  BarChart11Icon,
  BarChart12Icon,
  BarChartCircle01Icon,
  BarChartCircle02Icon,
  BarChartCircle03Icon,
  BarChartSquare01Icon,
  BarChartSquare02Icon,
  BarChartSquare03Icon,
  BarChartSquareDownIcon,
  BarChartSquareMinusIcon,
  BarChartSquarePlusIcon,
  BarChartSquareUpIcon,
  BarLineChartIcon,
  BatteryCharging01Icon,
  BatteryCharging02Icon,
  BatteryEmptyIcon,
  BatteryFullIcon,
  BatteryLowIcon,
  BatteryMidIcon,
  Beaker02Icon,
  Bell01Icon,
  BluetoothIcon,
  BluetoothConnectIcon,
  BluetoothOnIcon,
  BluetoothSignalIcon,
  Bold01Icon,
  Bookmark,
  BookmarkCheck,
  BookOpen01Icon,
  BoxIcon,
  BracketsEllipsesIcon,
  Briefcase01Icon,
  Briefcase02Icon,
  Building02Icon,
  Building05Icon,
  CalendarIcon,
  CalendarCheck01Icon,
  CalendarCheck02Icon,
  CalendarDateIcon,
  CalendarHeart01Icon,
  CalendarHeart02Icon,
  CalendarMinus01Icon,
  CalendarMinus02Icon,
  CalendarPlus01Icon,
  CalendarPlus02Icon,
  ChartBreakoutCircleIcon,
  ChartBreakoutSquareIcon,
  CheckCircleIcon,
  CheckDone01Icon,
  CheckIcon,
  CheckSquareBrokenIcon,
  CheckVerified01Icon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronSelectorVerticalIcon,
  ChevronUpIcon,
  ChromeCastIcon,
  ClapperboardIcon,
  ClockBarsIcon,
  ClockCheckIcon,
  ClockFastForwardIcon,
  ClockIcon,
  ClockPlusIcon,
  ClockRefreshIcon,
  ClockReportIcon,
  ClockRewindIcon,
  ClockSnoozeIcon,
  ClockStopwatchIcon,
  Cloud01Icon,
  Cloud02Icon,
  Cloud03Icon,
  CloudLightningIcon,
  CloudMoonIcon,
  CloudOffIcon,
  CloudRaining01Icon,
  CloudRaining02Icon,
  CloudRaining03Icon,
  CloudRaining04Icon,
  CloudRaining05Icon,
  CloudRaining06Icon,
  CloudSnowing01Icon,
  CloudSnowing02Icon,
  CloudSun01Icon,
  CloudSun02Icon,
  CloudSun03Icon,
  Code01Icon,
  Code02Icon,
  CoinsHandIcon,
  Column03Icon,
  Compass03Icon,
  ContainerIcon,
  Copy07Icon,
  CursorBoxIcon,
  CursorDollarCircleIcon,
  CurrencyDollarIcon,
  DataFlow01Icon,
  DataFlow03Icon,
  DataFlow05Icon,
  Disc01Icon,
  Disc02Icon,
  DistributeSpacingVerticalIcon,
  Dotpoints01Icon,
  Dotpoints02Icon,
  DotsGridIcon,
  DotsHorizontalIcon,
  DotsVerticalIcon,
  Droplets01Icon,
  Droplets02Icon,
  Droplets03Icon,
  Edit05Icon,
  Expand01Icon,
  Expand02Icon,
  EyeIcon,
  EyeOffIcon,
  FaceBigFrown,
  FaceBigSmile,
  FaceFrown,
  FaceId,
  FaceIdSquare,
  FaceNeutral,
  FaceSmileIcon,
  FastBackwardIcon,
  FastForwardIcon,
  File04Icon,
  FileCheck02Icon,
  FileDownload03Icon,
  FileLock01,
  FileLock02,
  FileLock03,
  FileSearch02Icon,
  FileShield01,
  FileShield02,
  FileShield03,
  FileX02Icon,
  Film01Icon,
  Film02Icon,
  Film03Icon,
  Fingerprint01,
  Fingerprint02,
  Fingerprint03,
  Fingerprint04,
  FilterFunnel01Icon,
  FilterLinesIcon,
  Flag01Icon,
  FolderShield,
  FolderPlus,
  ForkKnifeIcon,
  GamingPad01Icon,
  GamingPad02Icon,
  Gantt01Icon,
  Gantt02Icon,
  Gantt03Icon,
  Gantt04Icon,
  Gantt05Icon,
  Globe02Icon,
  Grid01Icon,
  GUIDEcxIcon,
  GuideUniversity,
  HardDriveIcon,
  Hash02Icon,
  Headphones01Icon,
  Headphones02Icon,
  HeadingLevel1,
  HeadingLevel2,
  HeadingLevel3,
  HeadingLevel4,
  HeadingLevel5,
  HeartIcon,
  HelpCircleIcon,
  HomeLineIcon,
  HorizontalBarChart01Icon,
  Hourglass01Icon,
  Hourglass02Icon,
  Hourglass03Icon,
  Hurricane01Icon,
  Hurricane02Icon,
  Hurricane03Icon,
  Image01Icon,
  Image03Icon,
  Inbox01,
  InfoCircleIcon,
  Italic01Icon,
  Key01,
  Key02,
  Keyboard01Icon,
  LayersThree01Icon,
  LifeBuoy01Icon,
  Lightbulb05Icon,
  Lightning01Icon,
  Lightning02Icon,
  Link01Icon,
  Link03Icon,
  LinkBroken03Icon,
  LinkExternal01Icon,
  ListIcon,
  Lock01Icon,
  Lock02,
  Lock04,
  LockKeyholeCircle,
  LockKeyholeSquare,
  LockUnlocked01,
  LockUnlocked03Icon,
  LockUnlocked04,
  LogOut01Icon,
  MailIcon,
  MentionIcon,
  Menu01Icon,
  Menu02Icon,
  Passcode,
  PasscodeLock,
  MessageChatSquare,
  MessageCheckSquareIcon,
  MessageCircle01,
  MessageNotificationSquare,
  MessageSquare02,
  MessageXSquareIcon,
  Minimize01Icon,
  MinusIcon,
  MoonIcon,
  Moon01Icon,
  Moon02Icon,
  MoonEclipseIcon,
  MoonStarIcon,
  NotePencilIcon,
  NotificationAtSignIcon,
  NotificationBell01Icon,
  NotificationBoxIcon,
  NotificationMessage,
  NumberedListIcon,
  PaperclipIcon,
  PauseCircleIcon,
  PawPrintIcon,
  Pencil01Icon,
  Percent02Icon,
  PhoneIcon,
  PieChart02Icon,
  PieChart03Icon,
  PieChart04Icon,
  Pilcrow01,
  Pilcrow02,
  PlaneIcon,
  PlayCircleIcon,
  PlayIcon,
  PlusIcon,
  PointerIcon,
  Power01Icon,
  PresentationChart01Icon,
  PresentationChart02Icon,
  PresentationChart03Icon,
  RedPower01Icon,
  Referral,
  ResourceManagementIcon,
  Rows03,
  Save01Icon,
  Scan,
  SearchLgIcon,
  SearchMdIcon,
  SearchSmIcon,
  Settings01Icon,
  Settings02Icon,
  Settings03Icon,
  Share02Icon,
  Shield01,
  Shield02,
  Shield03,
  ShieldDollar,
  ShieldOff,
  ShieldPlus,
  ShieldTick,
  ShieldZap,
  ShoppingCart01Icon,
  SoccerBallIcon,
  Snowflake01Icon,
  Snowflake02Icon,
  Star01Icon,
  Stars01Icon,
  Stars02Icon,
  Stars03Icon,
  StopIcon,
  StrikeThrough01,
  SunIcon,
  SunSetting01Icon,
  SunSetting02Icon,
  SunSetting03Icon,
  SunriseIcon,
  SunsetIcon,
  TableIcon,
  Tag01Icon,
  Tag03Icon,
  Thermometer01Icon,
  Thermometer02Icon,
  Thermometer03Icon,
  ThermometerColdIcon,
  ThermometerWarmIcon,
  Ticket01Icon,
  Toggle03LeftIcon,
  Toggle03RightIcon,
  Tool02Icon,
  Trash01Icon,
  TrendDown01Icon,
  TrendDown02Icon,
  TrendUp01Icon,
  TrendUp02Icon,
  Umbrella01Icon,
  Umbrella02Icon,
  Umbrella03Icon,
  Underline01Icon,
  UploadCloud02Icon,
  User01Icon,
  UserConfigIcon,
  UserCustomersIcon,
  UserLeft01Icon,
  UserMinus01Icon,
  UserPlusIcon,
  Users01Icon,
  UsersSquareIcon,
  UserX01Icon,
  VerifiedThickIcon,
  WatchCircleIcon,
  WatchSquareIcon,
  WavesIcon,
  Wind01Icon,
  Wind02Icon,
  Wind03Icon,
  XCircleIcon,
  XCloseIcon,
  XMarkIcon,
  XSmIcon,
} from '../Icons'

import './Icon.scss'

const Icons = {
  ai: ({ className }: SVGAttributes<SVGElement>) => (
    <AI className={className} />
  ),
  activity: ({ className }: SVGAttributes<SVGElement>) => (
    <ActivityIcon className={className} />
  ),
  align_center: ({ className }: SVGAttributes<SVGElement>) => (
    <AlignCenterIcon className={className} />
  ),
  alert_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <AlertCircleIcon className={className} />
  ),
  alert_triangle: ({ className }: SVGAttributes<SVGElement>) => (
    <AlertTriangleIcon className={className} />
  ),
  arrow_down: ({ className }: SVGAttributes<SVGElement>) => (
    <ArrowDownIcon className={className} />
  ),
  arrow_narrow_down_left: ({ className }: SVGAttributes<SVGElement>) => (
    <ArrowNarrowDownLeftIcon className={className} />
  ),
  arrow_narrow_up_right: ({ className }: SVGAttributes<SVGElement>) => (
    <ArrowNarrowUpRightIcon className={className} />
  ),
  arrow_right: ({ className }: SVGAttributes<SVGElement>) => (
    <ArrowRightIcon className={className} />
  ),
  arrow_left: ({ className }: SVGAttributes<SVGElement>) => (
    <ArrowLeftIcon className={className} />
  ),
  arrow_up: ({ className }: SVGAttributes<SVGElement>) => (
    <ArrowUpIcon className={className} />
  ),
  at_sign: ({ className }: SVGAttributes<SVGElement>) => (
    <AtSignIcon className={className} />
  ),
  attachment_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Attachment01Icon className={className} />
  ),
  bar_chart_01: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart01Icon className={className} />
  ),
  bar_chart_02: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart02Icon className={className} />
  ),
  bar_chart_03: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart03Icon className={className} />
  ),
  bar_chart_04: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart04Icon className={className} />
  ),
  bar_chart_05: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart05Icon className={className} />
  ),
  bar_chart_06: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart06Icon className={className} />
  ),
  bar_chart_07: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart07Icon className={className} />
  ),
  bar_chart_08: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart08Icon className={className} />
  ),
  bar_chart_09: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart09Icon className={className} />
  ),
  bar_chart_10: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart10Icon className={className} />
  ),
  bar_line_chart: ({ className }: SVGAttributes<SVGElement>) => (
    <BarLineChartIcon className={className} />
  ),
  beaker_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Beaker02Icon className={className} />
  ),
  bell_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Bell01Icon className={className} />
  ),
  bold_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Bold01Icon className={className} />
  ),
  box: ({ className }: SVGAttributes<SVGElement>) => (
    <BoxIcon className={className} />
  ),
  bookmark: ({ className }: SVGAttributes<SVGElement>) => (
    <Bookmark className={className} />
  ),
  bookmark_check: ({ className }: SVGAttributes<SVGElement>) => (
    <BookmarkCheck className={className} />
  ),
  book_open_01: ({ className }: SVGAttributes<SVGElement>) => (
    <BookOpen01Icon className={className} />
  ),
  brackets_ellipses: ({ className }: SVGAttributes<SVGElement>) => (
    <BracketsEllipsesIcon className={className} />
  ),
  briefcase_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Briefcase01Icon className={className} />
  ),
  briefcase_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Briefcase02Icon className={className} />
  ),
  building_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Building02Icon className={className} />
  ),
  building_05: ({ className }: SVGAttributes<SVGElement>) => (
    <Building05Icon className={className} />
  ),
  calendar: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarIcon className={className} />
  ),
  chart_breakout_square: ({ className }: SVGAttributes<SVGElement>) => (
    <ChartBreakoutSquareIcon className={className} />
  ),
  check: ({ className }: SVGAttributes<SVGElement>) => (
    <CheckIcon className={className} />
  ),
  check_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <CheckCircleIcon className={className} />
  ),
  check_done_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CheckDone01Icon className={className} />
  ),
  check_square_broken: ({ className }: SVGAttributes<SVGElement>) => (
    <CheckSquareBrokenIcon className={className} />
  ),
  chevron_down: ({ className }: SVGAttributes<SVGElement>) => (
    <ChevronDownIcon className={className} />
  ),
  chevron_left: ({ className }: SVGAttributes<SVGElement>) => (
    <ChevronLeftIcon className={className} />
  ),
  chevron_right: ({ className }: SVGAttributes<SVGElement>) => (
    <ChevronRightIcon className={className} />
  ),
  chevron_selector_vertical: ({ className }: SVGAttributes<SVGElement>) => (
    <ChevronSelectorVerticalIcon className={className} />
  ),
  chevron_up: ({ className }: SVGAttributes<SVGElement>) => (
    <ChevronUpIcon className={className} />
  ),
  clock_plus: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockPlusIcon className={className} />
  ),
  clock_fast_forward: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockFastForwardIcon className={className} />
  ),
  clock_report: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockReportIcon className={className} />
  ),
  clock_stopwatch: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockStopwatchIcon className={className} />
  ),
  clock: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockIcon className={className} />
  ),
  code_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Code01Icon className={className} />
  ),
  code_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Code02Icon className={className} />
  ),
  coins_hand: ({ className }: SVGAttributes<SVGElement>) => (
    <CoinsHandIcon className={className} />
  ),
  compass_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Compass03Icon className={className} />
  ),
  column_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Column03Icon className={className} />
  ),
  container: ({ className }: SVGAttributes<SVGElement>) => (
    <ContainerIcon className={className} />
  ),
  copy_07: ({ className }: SVGAttributes<SVGElement>) => (
    <Copy07Icon className={className} />
  ),
  currency_dollar: ({ className }: SVGAttributes<SVGElement>) => (
    <CurrencyDollarIcon className={className} />
  ),
  currency_dollar_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <CursorDollarCircleIcon className={className} />
  ),
  cursor_box: ({ className }: SVGAttributes<SVGElement>) => (
    <CursorBoxIcon className={className} />
  ),
  data_flow_01: ({ className }: SVGAttributes<SVGElement>) => (
    <DataFlow01Icon className={className} />
  ),
  data_flow_03: ({ className }: SVGAttributes<SVGElement>) => (
    <DataFlow03Icon className={className} />
  ),
  data_flow_05: ({ className }: SVGAttributes<SVGElement>) => (
    <DataFlow05Icon className={className} />
  ),
  distribute_spacing_vertical: ({ className }: SVGAttributes<SVGElement>) => (
    <DistributeSpacingVerticalIcon className={className} />
  ),
  dots_grid: ({ className }: SVGAttributes<SVGElement>) => (
    <DotsGridIcon className={className} />
  ),
  dots_horizontal: ({ className }: SVGAttributes<SVGElement>) => (
    <DotsHorizontalIcon className={className} />
  ),
  dotpoints_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Dotpoints01Icon className={className} />
  ),
  dotpoints_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Dotpoints02Icon className={className} />
  ),
  dots_vertical: ({ className }: SVGAttributes<SVGElement>) => (
    <DotsVerticalIcon className={className} />
  ),
  edit_05: ({ className }: SVGAttributes<SVGElement>) => (
    <Edit05Icon className={className} />
  ),
  eye: ({ className }: SVGAttributes<SVGElement>) => (
    <EyeIcon className={className} />
  ),
  eye_off: ({ className }: SVGAttributes<SVGElement>) => (
    <EyeOffIcon className={className} />
  ),
  expand_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Expand01Icon className={className} />
  ),
  expand_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Expand02Icon className={className} />
  ),
  face_smile: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceSmileIcon className={className} />
  ),
  face_id: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceId className={className} />
  ),
  face_id_square: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceIdSquare className={className} />
  ),
  face_big_frown: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceBigFrown className={className} />
  ),
  face_big_smile: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceBigSmile className={className} />
  ),
  face_neutral: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceNeutral className={className} />
  ),
  face_frown: ({ className }: SVGAttributes<SVGElement>) => (
    <FaceFrown className={className} />
  ),
  file_04: ({ className }: SVGAttributes<SVGElement>) => (
    <File04Icon className={className} />
  ),
  file_check_02: ({ className }: SVGAttributes<SVGElement>) => (
    <FileCheck02Icon className={className} />
  ),
  file_download_03: ({ className }: SVGAttributes<SVGElement>) => (
    <FileDownload03Icon className={className} />
  ),
  file_lock_01: ({ className }: SVGAttributes<SVGElement>) => (
    <FileLock01 className={className} />
  ),
  file_lock_02: ({ className }: SVGAttributes<SVGElement>) => (
    <FileLock02 className={className} />
  ),
  file_lock_03: ({ className }: SVGAttributes<SVGElement>) => (
    <FileLock03 className={className} />
  ),
  file_search_02: ({ className }: SVGAttributes<SVGElement>) => (
    <FileSearch02Icon className={className} />
  ),
  file_shield_01: ({ className }: SVGAttributes<SVGElement>) => (
    <FileShield01 className={className} />
  ),
  file_shield_02: ({ className }: SVGAttributes<SVGElement>) => (
    <FileShield02 className={className} />
  ),
  file_shield_03: ({ className }: SVGAttributes<SVGElement>) => (
    <FileShield03 className={className} />
  ),
  file_x_02: ({ className }: SVGAttributes<SVGElement>) => (
    <FileX02Icon className={className} />
  ),
  film_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Film01Icon className={className} />
  ),
  fingerprint_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Fingerprint01 className={className} />
  ),
  fingerprint_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Fingerprint02 className={className} />
  ),
  fingerprint_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Fingerprint03 className={className} />
  ),
  fingerprint_04: ({ className }: SVGAttributes<SVGElement>) => (
    <Fingerprint04 className={className} />
  ),
  filter_funnel_01: ({ className }: SVGAttributes<SVGElement>) => (
    <FilterFunnel01Icon className={className} />
  ),
  filter_lines: ({ className }: SVGAttributes<SVGElement>) => (
    <FilterLinesIcon className={className} />
  ),
  flag_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Flag01Icon className={className} />
  ),
  folder_shield: ({ className }: SVGAttributes<SVGElement>) => (
    <FolderShield className={className} />
  ),
  folder_plus: ({ className }: SVGAttributes<SVGElement>) => (
    <FolderPlus className={className} />
  ),
  fork_knife: ({ className }: SVGAttributes<SVGElement>) => (
    <ForkKnifeIcon className={className} />
  ),
  gantt_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Gantt03Icon className={className} />
  ),
  gantt_05: ({ className }: SVGAttributes<SVGElement>) => (
    <Gantt05Icon className={className} />
  ),
  globe_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Globe02Icon className={className} />
  ),
  grid_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Grid01Icon className={className} />
  ),
  hash_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Hash02Icon className={className} />
  ),
  heart: ({ className }: SVGAttributes<SVGElement>) => (
    <HeartIcon className={className} />
  ),
  heading_level_1: ({ className }: SVGAttributes<SVGElement>) => (
    <HeadingLevel1 className={className} />
  ),
  heading_level_2: ({ className }: SVGAttributes<SVGElement>) => (
    <HeadingLevel2 className={className} />
  ),
  heading_level_3: ({ className }: SVGAttributes<SVGElement>) => (
    <HeadingLevel3 className={className} />
  ),
  heading_level_4: ({ className }: SVGAttributes<SVGElement>) => (
    <HeadingLevel4 className={className} />
  ),
  heading_level_5: ({ className }: SVGAttributes<SVGElement>) => (
    <HeadingLevel5 className={className} />
  ),
  help_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <HelpCircleIcon className={className} />
  ),
  horizontal_bar_chart_01: ({ className }: SVGAttributes<SVGElement>) => (
    <HorizontalBarChart01Icon className={className} />
  ),
  image_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Image01Icon className={className} />
  ),
  image_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Image03Icon className={className} />
  ),
  inbox_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Inbox01 className={className} />
  ),
  info_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <InfoCircleIcon className={className} />
  ),
  italic_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Italic01Icon className={className} />
  ),
  key_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Key01 className={className} />
  ),
  key_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Key02 className={className} />
  ),
  layers_three_01: ({ className }: SVGAttributes<SVGElement>) => (
    <LayersThree01Icon className={className} />
  ),
  life_buoy_01: ({ className }: SVGAttributes<SVGElement>) => (
    <LifeBuoy01Icon className={className} />
  ),
  lightbulb_05: ({ className }: SVGAttributes<SVGElement>) => (
    <Lightbulb05Icon className={className} />
  ),
  link_broken_02: ({ className }: SVGAttributes<SVGElement>) => (
    <LinkBroken03Icon className={className} />
  ),
  link_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Link01Icon className={className} />
  ),
  link_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Link03Icon className={className} />
  ),
  link_external_01: ({ className }: SVGAttributes<SVGElement>) => (
    <LinkExternal01Icon className={className} />
  ),
  list: ({ className }: SVGAttributes<SVGElement>) => (
    <ListIcon className={className} />
  ),
  lock_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Lock01Icon className={className} />
  ),
  lock_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Lock02 className={className} />
  ),
  lock_04: ({ className }: SVGAttributes<SVGElement>) => (
    <Lock04 className={className} />
  ),
  lock_keyhole_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <LockKeyholeCircle className={className} />
  ),
  lock_keyhole_square: ({ className }: SVGAttributes<SVGElement>) => (
    <LockKeyholeSquare className={className} />
  ),
  lock_unlocked_01: ({ className }: SVGAttributes<SVGElement>) => (
    <LockUnlocked01 className={className} />
  ),
  lock_unlocked_03: ({ className }: SVGAttributes<SVGElement>) => (
    <LockUnlocked03Icon className={className} />
  ),
  lock_unlocked_04: ({ className }: SVGAttributes<SVGElement>) => (
    <LockUnlocked04 className={className} />
  ),
  log_out_01: ({ className }: SVGAttributes<SVGElement>) => (
    <LogOut01Icon className={className} />
  ),
  mail: ({ className }: SVGAttributes<SVGElement>) => (
    <MailIcon className={className} />
  ),
  mention: ({ className }: SVGAttributes<SVGElement>) => (
    <MentionIcon className={className} />
  ),
  menu_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Menu01Icon className={className} />
  ),
  passcode: ({ className }: SVGAttributes<SVGElement>) => (
    <Passcode className={className} />
  ),
  passcode_lock: ({ className }: SVGAttributes<SVGElement>) => (
    <PasscodeLock className={className} />
  ),
  menu_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Menu02Icon className={className} />
  ),
  message_chat_square: ({ className }: SVGAttributes<SVGElement>) => (
    <MessageChatSquare className={className} />
  ),
  message_check_square: ({ className }: SVGAttributes<SVGElement>) => (
    <MessageCheckSquareIcon className={className} />
  ),
  message_x_square: ({ className }: SVGAttributes<SVGElement>) => (
    <MessageXSquareIcon className={className} />
  ),
  message_circle_01: ({ className }: SVGAttributes<SVGElement>) => (
    <MessageCircle01 className={className} />
  ),
  message_notification_square: ({ className }: SVGAttributes<SVGElement>) => (
    <MessageNotificationSquare className={className} />
  ),
  message_square_02: ({ className }: SVGAttributes<SVGElement>) => (
    <MessageSquare02 className={className} />
  ),
  minus: ({ className }: SVGAttributes<SVGElement>) => (
    <MinusIcon className={className} />
  ),
  minimize_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Minimize01Icon className={className} />
  ),
  moon: ({ className }: SVGAttributes<SVGElement>) => (
    <MoonIcon className={className} />
  ),
  notification_at_sign: ({ className }: SVGAttributes<SVGElement>) => (
    <NotificationAtSignIcon className={className} />
  ),
  notification_bell_01: ({ className }: SVGAttributes<SVGElement>) => (
    <NotificationBell01Icon className={className} />
  ),
  notification_box: ({ className }: SVGAttributes<SVGElement>) => (
    <NotificationBoxIcon className={className} />
  ),
  notification_message: ({ className }: SVGAttributes<SVGElement>) => (
    <NotificationMessage className={className} />
  ),
  note_pencil: ({ className }: SVGAttributes<SVGElement>) => (
    <NotePencilIcon className={className} />
  ),
  numbered_list: ({ className }: SVGAttributes<SVGElement>) => (
    <NumberedListIcon className={className} />
  ),
  paperclip: ({ className }: SVGAttributes<SVGElement>) => (
    <PaperclipIcon className={className} />
  ),
  pause_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <PauseCircleIcon className={className} />
  ),
  paw_print: ({ className }: SVGAttributes<SVGElement>) => (
    <PawPrintIcon className={className} />
  ),
  pencil_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Pencil01Icon className={className} />
  ),
  percent_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Percent02Icon className={className} />
  ),
  phone: ({ className }: SVGAttributes<SVGElement>) => (
    <PhoneIcon className={className} />
  ),
  pie_chart_03: ({ className }: SVGAttributes<SVGElement>) => (
    <PieChart03Icon className={className} />
  ),
  pilcrow_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Pilcrow01 className={className} />
  ),
  pilcrow_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Pilcrow02 className={className} />
  ),
  plane: ({ className }: SVGAttributes<SVGElement>) => (
    <PlaneIcon className={className} />
  ),
  play: ({ className }: SVGAttributes<SVGElement>) => (
    <PlayIcon className={className} />
  ),
  play_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <PlayCircleIcon className={className} />
  ),
  plus: ({ className }: SVGAttributes<SVGElement>) => (
    <PlusIcon className={className} />
  ),
  pointer: ({ className }: SVGAttributes<SVGElement>) => (
    <PointerIcon className={className} />
  ),
  power_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Power01Icon className={className} />
  ),
  presentation_chart_01: ({ className }: SVGAttributes<SVGElement>) => (
    <PresentationChart01Icon className={className} />
  ),
  referral: ({ className }: SVGAttributes<SVGElement>) => (
    <Referral className={className} />
  ),
  red_power_01: ({ className }: SVGAttributes<SVGElement>) => (
    <RedPower01Icon className={className} />
  ),
  resource_management: ({ className }: SVGAttributes<SVGElement>) => (
    <ResourceManagementIcon className={className} />
  ),
  rows_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Rows03 className={className} />
  ),
  save_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Save01Icon className={className} />
  ),
  scan: ({ className }: SVGAttributes<SVGElement>) => (
    <Scan className={className} />
  ),
  search_sm: ({ className }: SVGAttributes<SVGElement>) => (
    <SearchSmIcon className={className} />
  ),
  search_md: ({ className }: SVGAttributes<SVGElement>) => (
    <SearchMdIcon className={className} />
  ),
  search_lg: ({ className }: SVGAttributes<SVGElement>) => (
    <SearchLgIcon className={className} />
  ),
  settings_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Settings01Icon className={className} />
  ),
  settings_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Settings02Icon className={className} />
  ),
  settings_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Settings03Icon className={className} />
  ),
  share_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Share02Icon className={className} />
  ),
  shield_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Shield01 className={className} />
  ),
  shield_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Shield02 className={className} />
  ),
  shield_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Shield03 className={className} />
  ),
  shield_dollar: ({ className }: SVGAttributes<SVGElement>) => (
    <ShieldDollar className={className} />
  ),
  shield_off: ({ className }: SVGAttributes<SVGElement>) => (
    <ShieldOff className={className} />
  ),
  shield_plus: ({ className }: SVGAttributes<SVGElement>) => (
    <ShieldPlus className={className} />
  ),
  shield_tick: ({ className }: SVGAttributes<SVGElement>) => (
    <ShieldTick className={className} />
  ),
  shield_zap: ({ className }: SVGAttributes<SVGElement>) => (
    <ShieldZap className={className} />
  ),
  shopping_cart_01: ({ className }: SVGAttributes<SVGElement>) => (
    <ShoppingCart01Icon className={className} />
  ),
  soccer_ball: ({ className }: SVGAttributes<SVGElement>) => (
    <SoccerBallIcon className={className} />
  ),
  star_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Star01Icon className={className} />
  ),
  stop: ({ className }: SVGAttributes<SVGElement>) => (
    <StopIcon className={className} />
  ),
  strikethrough_01: ({ className }: SVGAttributes<SVGElement>) => (
    <StrikeThrough01 className={className} />
  ),
  sun: ({ className }: SVGAttributes<SVGElement>) => (
    <SunIcon className={className} />
  ),
  table: ({ className }: SVGAttributes<SVGElement>) => (
    <TableIcon className={className} />
  ),
  tag_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Tag01Icon className={className} />
  ),
  tag_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Tag03Icon className={className} />
  ),
  toggle_03_left: ({ className }: SVGAttributes<SVGElement>) => (
    <Toggle03LeftIcon className={className} />
  ),
  toggle_03_right: ({ className }: SVGAttributes<SVGElement>) => (
    <Toggle03RightIcon className={className} />
  ),
  tool_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Tool02Icon className={className} />
  ),
  trash_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Trash01Icon className={className} />
  ),
  upload_cloud_02: ({ className }: SVGAttributes<SVGElement>) => (
    <UploadCloud02Icon className={className} />
  ),
  underline_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Underline01Icon className={className} />
  ),
  user_01: ({ className }: SVGAttributes<SVGElement>) => (
    <User01Icon className={className} />
  ),
  user_config: ({ className }: SVGAttributes<SVGElement>) => (
    <UserConfigIcon className={className} />
  ),
  user_customers: ({ className }: SVGAttributes<SVGElement>) => (
    <UserCustomersIcon className={className} />
  ),
  user_plus: ({ className }: SVGAttributes<SVGElement>) => (
    <UserPlusIcon className={className} />
  ),
  user_left_01: ({ className }: SVGAttributes<SVGElement>) => (
    <UserLeft01Icon className={className} />
  ),
  users_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Users01Icon className={className} />
  ),
  user_minus_01: ({ className }: SVGAttributes<SVGElement>) => (
    <UserMinus01Icon className={className} />
  ),
  user_x_01: ({ className }: SVGAttributes<SVGElement>) => (
    <UserX01Icon className={className} />
  ),
  users_square: ({ className }: SVGAttributes<SVGElement>) => (
    <UsersSquareIcon className={className} />
  ),
  verified_thick: ({ className }: SVGAttributes<SVGElement>) => (
    <VerifiedThickIcon className={className} />
  ),
  x_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <XCircleIcon className={className} />
  ),
  x_mark: ({ className }: SVGAttributes<SVGElement>) => (
    <XMarkIcon className={className} />
  ),
  x_close: ({ className }: SVGAttributes<SVGElement>) => (
    <XCloseIcon className={className} />
  ),
  x_sm: ({ className }: SVGAttributes<SVGElement>) => (
    <XSmIcon className={className} />
  ),
  home_line: ({ className }: SVGAttributes<SVGElement>) => (
    <HomeLineIcon className={className} />
  ),
  guidecx_dark: ({ className }: SVGAttributes<SVGElement>) => (
    <GUIDEcxIcon className={className} />
  ),
  check_verified_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CheckVerified01Icon className={className} />
  ),
  guide_university: ({ className }: SVGAttributes<SVGElement>) => (
    <GuideUniversity className={className} />
  ),
  ticket_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Ticket01Icon className={className} />
  ),
  airplay: ({ className }: SVGAttributes<SVGElement>) => (
    <Airplay className={className} />
  ),
  airpods: ({ className }: SVGAttributes<SVGElement>) => (
    <Airpods className={className} />
  ),
  alarm_clock: ({ className }: SVGAttributes<SVGElement>) => (
    <AlarmClock className={className} />
  ),
  alarm_clock_check: ({ className }: SVGAttributes<SVGElement>) => (
    <AlarmClockCheck className={className} />
  ),
  alarm_clock_minus: ({ className }: SVGAttributes<SVGElement>) => (
    <AlarmClockMinus className={className} />
  ),
  alarm_clock_off: ({ className }: SVGAttributes<SVGElement>) => (
    <AlarmClockOff className={className} />
  ),
  alarm_clock_plus: ({ className }: SVGAttributes<SVGElement>) => (
    <AlarmClockPlus className={className} />
  ),
  bar_chart_11: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart11Icon className={className} />
  ),
  bar_chart_12: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChart12Icon className={className} />
  ),
  bar_chart_circle_01: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartCircle01Icon className={className} />
  ),
  bar_chart_circle_02: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartCircle02Icon className={className} />
  ),
  bar_chart_circle_03: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartCircle03Icon className={className} />
  ),
  bar_chart_square_01: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquare01Icon className={className} />
  ),
  bar_chart_square_02: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquare02Icon className={className} />
  ),
  bar_chart_square_03: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquare03Icon className={className} />
  ),
  bar_chart_square_down: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquareDownIcon className={className} />
  ),
  bar_chart_square_minus: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquareMinusIcon className={className} />
  ),
  bar_chart_square_plus: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquarePlusIcon className={className} />
  ),
  bar_chart_square_up: ({ className }: SVGAttributes<SVGElement>) => (
    <BarChartSquareUpIcon className={className} />
  ),
  battery_charging_01: ({ className }: SVGAttributes<SVGElement>) => (
    <BatteryCharging01Icon className={className} />
  ),
  battery_charging_02: ({ className }: SVGAttributes<SVGElement>) => (
    <BatteryCharging02Icon className={className} />
  ),
  battery_empty: ({ className }: SVGAttributes<SVGElement>) => (
    <BatteryEmptyIcon className={className} />
  ),
  battery_full: ({ className }: SVGAttributes<SVGElement>) => (
    <BatteryFullIcon className={className} />
  ),
  battery_low: ({ className }: SVGAttributes<SVGElement>) => (
    <BatteryLowIcon className={className} />
  ),
  battery_mid: ({ className }: SVGAttributes<SVGElement>) => (
    <BatteryMidIcon className={className} />
  ),
  bluetooth: ({ className }: SVGAttributes<SVGElement>) => (
    <BluetoothIcon className={className} />
  ),
  bluetooth_connect: ({ className }: SVGAttributes<SVGElement>) => (
    <BluetoothConnectIcon className={className} />
  ),
  bluetooth_on: ({ className }: SVGAttributes<SVGElement>) => (
    <BluetoothOnIcon className={className} />
  ),
  bluetooth_signal: ({ className }: SVGAttributes<SVGElement>) => (
    <BluetoothSignalIcon className={className} />
  ),
  calendar_check_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarCheck01Icon className={className} />
  ),
  calendar_check_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarCheck02Icon className={className} />
  ),
  calendar_date: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarDateIcon className={className} />
  ),
  calendar_heart_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarHeart01Icon className={className} />
  ),
  calendar_heart_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarHeart02Icon className={className} />
  ),
  calendar_minus_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarMinus01Icon className={className} />
  ),
  calendar_minus_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarMinus02Icon className={className} />
  ),
  calendar_plus_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarPlus01Icon className={className} />
  ),
  calendar_plus_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CalendarPlus02Icon className={className} />
  ),
  chart_breakout_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <ChartBreakoutCircleIcon className={className} />
  ),
  chrome_cast: ({ className }: SVGAttributes<SVGElement>) => (
    <ChromeCastIcon className={className} />
  ),
  clapperboard: ({ className }: SVGAttributes<SVGElement>) => (
    <ClapperboardIcon className={className} />
  ),
  clock_bars: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockBarsIcon className={className} />
  ),
  clock_check: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockCheckIcon className={className} />
  ),
  clock_refresh: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockRefreshIcon className={className} />
  ),
  clock_rewind: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockRewindIcon className={className} />
  ),
  clock_snooze: ({ className }: SVGAttributes<SVGElement>) => (
    <ClockSnoozeIcon className={className} />
  ),
  cloud_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Cloud01Icon className={className} />
  ),
  cloud_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Cloud02Icon className={className} />
  ),
  cloud_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Cloud03Icon className={className} />
  ),
  cloud_lightning: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudLightningIcon className={className} />
  ),
  cloud_moon: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudMoonIcon className={className} />
  ),
  cloud_off: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudOffIcon className={className} />
  ),
  cloud_raining_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudRaining01Icon className={className} />
  ),
  cloud_raining_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudRaining02Icon className={className} />
  ),
  cloud_raining_03: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudRaining03Icon className={className} />
  ),
  cloud_raining_04: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudRaining04Icon className={className} />
  ),
  cloud_raining_05: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudRaining05Icon className={className} />
  ),
  cloud_raining_06: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudRaining06Icon className={className} />
  ),
  cloud_snowing_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudSnowing01Icon className={className} />
  ),
  cloud_snowing_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudSnowing02Icon className={className} />
  ),
  cloud_sun_01: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudSun01Icon className={className} />
  ),
  cloud_sun_02: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudSun02Icon className={className} />
  ),
  cloud_sun_03: ({ className }: SVGAttributes<SVGElement>) => (
    <CloudSun03Icon className={className} />
  ),
  disc_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Disc01Icon className={className} />
  ),
  disc_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Disc02Icon className={className} />
  ),
  droplets_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Droplets01Icon className={className} />
  ),
  droplets_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Droplets02Icon className={className} />
  ),
  droplets_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Droplets03Icon className={className} />
  ),
  fast_backward: ({ className }: SVGAttributes<SVGElement>) => (
    <FastBackwardIcon className={className} />
  ),
  fast_forward: ({ className }: SVGAttributes<SVGElement>) => (
    <FastForwardIcon className={className} />
  ),
  film_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Film02Icon className={className} />
  ),
  film_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Film03Icon className={className} />
  ),
  gaming_pad_01: ({ className }: SVGAttributes<SVGElement>) => (
    <GamingPad01Icon className={className} />
  ),
  gaming_pad_02: ({ className }: SVGAttributes<SVGElement>) => (
    <GamingPad02Icon className={className} />
  ),
  gantt_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Gantt01Icon className={className} />
  ),
  gantt_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Gantt02Icon className={className} />
  ),
  gantt_04: ({ className }: SVGAttributes<SVGElement>) => (
    <Gantt04Icon className={className} />
  ),
  hard_drive: ({ className }: SVGAttributes<SVGElement>) => (
    <HardDriveIcon className={className} />
  ),
  headphones_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Headphones01Icon className={className} />
  ),
  headphones_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Headphones02Icon className={className} />
  ),
  hourglass_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Hourglass01Icon className={className} />
  ),
  hourglass_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Hourglass02Icon className={className} />
  ),
  hourglass_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Hourglass03Icon className={className} />
  ),
  hurricane_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Hurricane01Icon className={className} />
  ),
  hurricane_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Hurricane02Icon className={className} />
  ),
  hurricane_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Hurricane03Icon className={className} />
  ),
  keyboard_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Keyboard01Icon className={className} />
  ),
  lightning_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Lightning01Icon className={className} />
  ),
  lightning_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Lightning02Icon className={className} />
  ),
  moon_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Moon01Icon className={className} />
  ),
  moon_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Moon02Icon className={className} />
  ),
  moon_eclipse: ({ className }: SVGAttributes<SVGElement>) => (
    <MoonEclipseIcon className={className} />
  ),
  moon_star: ({ className }: SVGAttributes<SVGElement>) => (
    <MoonStarIcon className={className} />
  ),
  pie_chart_02: ({ className }: SVGAttributes<SVGElement>) => (
    <PieChart02Icon className={className} />
  ),
  pie_chart_04: ({ className }: SVGAttributes<SVGElement>) => (
    <PieChart04Icon className={className} />
  ),
  presentation_chart_02: ({ className }: SVGAttributes<SVGElement>) => (
    <PresentationChart02Icon className={className} />
  ),
  presentation_chart_03: ({ className }: SVGAttributes<SVGElement>) => (
    <PresentationChart03Icon className={className} />
  ),
  snowflake_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Snowflake01Icon className={className} />
  ),
  snowflake_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Snowflake02Icon className={className} />
  ),
  stars_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Stars01Icon className={className} />
  ),
  stars_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Stars02Icon className={className} />
  ),
  stars_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Stars03Icon className={className} />
  ),
  sun_setting_01: ({ className }: SVGAttributes<SVGElement>) => (
    <SunSetting01Icon className={className} />
  ),
  sun_setting_02: ({ className }: SVGAttributes<SVGElement>) => (
    <SunSetting02Icon className={className} />
  ),
  sun_setting_03: ({ className }: SVGAttributes<SVGElement>) => (
    <SunSetting03Icon className={className} />
  ),
  sunrise: ({ className }: SVGAttributes<SVGElement>) => (
    <SunriseIcon className={className} />
  ),
  sunset: ({ className }: SVGAttributes<SVGElement>) => (
    <SunsetIcon className={className} />
  ),
  thermometer_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Thermometer01Icon className={className} />
  ),
  thermometer_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Thermometer02Icon className={className} />
  ),
  thermometer_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Thermometer03Icon className={className} />
  ),
  thermometer_cold: ({ className }: SVGAttributes<SVGElement>) => (
    <ThermometerColdIcon className={className} />
  ),
  thermometer_warm: ({ className }: SVGAttributes<SVGElement>) => (
    <ThermometerWarmIcon className={className} />
  ),
  trend_down_01: ({ className }: SVGAttributes<SVGElement>) => (
    <TrendDown01Icon className={className} />
  ),
  trend_down_02: ({ className }: SVGAttributes<SVGElement>) => (
    <TrendDown02Icon className={className} />
  ),
  trend_up_01: ({ className }: SVGAttributes<SVGElement>) => (
    <TrendUp01Icon className={className} />
  ),
  trend_up_02: ({ className }: SVGAttributes<SVGElement>) => (
    <TrendUp02Icon className={className} />
  ),
  umbrella_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Umbrella01Icon className={className} />
  ),
  umbrella_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Umbrella02Icon className={className} />
  ),
  umbrella_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Umbrella03Icon className={className} />
  ),
  watch_circle: ({ className }: SVGAttributes<SVGElement>) => (
    <WatchCircleIcon className={className} />
  ),
  watch_square: ({ className }: SVGAttributes<SVGElement>) => (
    <WatchSquareIcon className={className} />
  ),
  waves: ({ className }: SVGAttributes<SVGElement>) => (
    <WavesIcon className={className} />
  ),
  wind_01: ({ className }: SVGAttributes<SVGElement>) => (
    <Wind01Icon className={className} />
  ),
  wind_02: ({ className }: SVGAttributes<SVGElement>) => (
    <Wind02Icon className={className} />
  ),
  wind_03: ({ className }: SVGAttributes<SVGElement>) => (
    <Wind03Icon className={className} />
  ),
}

export { Icons }
export type IconName = keyof typeof Icons
export type IconSize = Extract<
  DSSizes,
  '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'
>
export type IconBackground = 'none' | 'error' | 'info' | 'success' | 'warning'

export interface IconProps {
  icon: IconName
  size?: IconSize
  background?: IconBackground
  'data-testid'?: string
  className?: string
  iconWrapperClassName?: string
  'flip-x'?: boolean
}

const Icon = ({
  icon,
  size = 'md',
  background = 'none',
  className = '',
  iconWrapperClassName = '',
  'data-testid': dataTestId,
  'flip-x': flipX = false,
}: IconProps) => {
  const IconComponent = Icons[icon]
  const style = flipX ? { transform: 'scaleX(-1)' } : {}

  // If there is NO background, return only the IconComponent
  if (background === 'none')
    return (
      <span
        className={classy('Icon__Wrapper', iconWrapperClassName)}
        data-testid={dataTestId || `icon-${icon}`}
        data-icon={icon}
        style={style}
      >
        <IconComponent className={`Icon__Component--${size} ${className}`} />
      </span>
    )

  // If there is a background, return the outer/inner and icon elements
  return (
    <span
      className={[
        'Icon__OuterBackground',
        `Icon__OuterBackground--${size}`,
        `Icon__OuterBackground--${background}`,
        iconWrapperClassName,
      ].join(' ')}
      data-icon={icon}
      data-testid={dataTestId || `icon-${icon}`}
      data-background={background}
    >
      <span
        className={[
          'Icon__InnerBackground',
          `Icon__InnerBackground--${size}`,
          `Icon__InnerBackground--${background}`,
        ].join(' ')}
      >
        <span className="Icon__Wrapper">
          <IconComponent className={`Icon__Component--${size} ${className}`} />
        </span>
      </span>
    </span>
  )
}

export default Icon
